/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import DocumentModal from '../../Components/CartItemCard/DocumentModal'
import EubSummarySection from './EubSummarySection'

export default function EUBSummary({ Calculation, Summary, GetCalculation,
    prod,
    items,
    orderFlow,
    CreateOrder,
    handleFlow,
    setdocumentModal,
    documentModal,
    adorCashCheck,
    Privilages,
    setadorCashCheck }) {
    const [type, settype] = useState('order');
    const [document, setdocument] = useState({
        instruction: '',
        PO_details: '',
        attach_po: [],
        attach_file: [],
        eu_name: ''
    })
    const cartCategory = [...new Set((items?.items || []).map((item) => item.MAIN_CATEGORY).filter(Boolean))][0]
    const [loader, setloader] = useState(false)
    const [euNameError, setEuNameError] = useState(false)
    const [restrictOrder, setRestrictOrder] = useState(Calculation?.summary?.restrict_order);
    const [restrictTradeEUBOrder, setRestrictTradeEUBOrder] = useState(Calculation?.summary?.restrict_ador_cash_order);
    const [restrictTradeAdorCash,setRestrictTradeAdorCash] = useState(Calculation?.summary?.restrict_order)
    const [restrictEubAdorCash,setTradeRestrictEubAdorCash] = useState(Calculation?.summary?.restrict_ador_cash_trade_eub_order)
    const handleSubmit = () => {
        if (loader === false) {
            CreateOrder(document).then((res) => {
                if (res) {
                    setdocumentModal(false)
                    setloader(false)
                }
            })
        }
    }
    // const handlePlaceOrder = () => {
    //     if (restrictOrder) {

    //     } else {
    //         setdocumentModal(true)
    //     }

    // }
    useEffect(() => {
        setRestrictOrder(Calculation?.summary?.restrict_order);
        setRestrictTradeEUBOrder(Calculation?.summary?.restrict_trade_eub_order)
    },[Calculation])
    const handleAmount = (value) => {
        const number = Number(value)?.toLocaleString('en-IN', {
            style: 'currency',
            currency: 'INR',
        })
        return number
    }

    return (
        <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 20 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.15 }}
            className='lg:w-[30%] w-full lg:mt-0 mt-4 lg:ml-[26px]'
        >
            <div
                className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
                <div className="border-b border-[#CBCBCB] pb-2.5">
                    <div className="flex justify-between">
                        <p className="text-sm font-semibold text-[#090406]">Order Type</p>

                        <p className="text-xs3 font-normal text-[#555259] " style={{ maxWidth: '500px', flexWrap: 'wrap' }}>Total Order Qty.:
                            {Object.keys(items?.summary?.quantity).length > 0 && Object.keys(items?.summary?.quantity).map((UOM, i) => (
                                <span style={{ float: `${i === 0 ? '' : 'right'}` }} key={UOM} className={`font-semibold`}>{Number(items?.summary?.quantity[UOM])} {UOM} <br /></span>
                            ))}</p>
                    </div>
                    <p className="sm:text-lg text-base font-normal text-[#555259]">{orderFlow.order_type}</p>
                </div>
                <div className="mt-3 border-b border-[#CBCBCB]">
                    <p className="text-sm font-semibold text-[#090406]">Quantity</p>
                    <div className="items-center flex justify-between mt-2">
                        <p className="font-normal text-sm text-[#555259]">Line Items selected</p>
                        <p className="font-normal text-sm text-[#555259]">{items?.items.length}</p>
                    </div>
                    <div className="items-center flex justify-between mt-2 pb-3">
                        <p className="font-normal text-sm text-[#555259]">Net Order Quantity</p>
                        <p className="font-normal text-sm text-[#555259]">{Object.keys(items?.summary?.quantity).length > 0 && Object.keys(items?.summary?.quantity).map((UOM, i) => (
                            <p style={{ float: `${i === 0 ? '' : 'right'}` }} key={UOM} className={`text-xs3 font-normal text-[#555259]`}>{Number(items?.summary?.quantity[UOM])} {UOM}{' '} <br /></p>
                        ))}</p>
                    </div>
                </div>
                <div className="pt-1.5">
                    {orderFlow.order_type === 'Trade EUB Order' ?

                        <ul className="nav nav-pills flex list-none pl-0 pb-1.5 border-b border-[#CBCBCB]"
                            id="pills-tab" role="tablist">
                            <>
                                <li className="nav-item w-1/2 text-center" role="presentation" onClick={() => settype('order')}>
                                    <a href="javascript:void(0)"
                                        className={`w-full nav-link block text-xs21 font-semibold text-[#808285] order-summary ${type === 'order' && orderFlow.order_type === 'Trade EUB Order' ? 'active' : ''} relative`}
                                        id="pills-home-tab"
                                        data-bs-toggle="pill" data-bs-target="#pills-home" role="tab" aria-controls="pills-home"
                                        aria-selected="true">
                                        Order Summary
                                    </a>
                                </li>
                                <li className="nav-item w-1/2 text-center" role="presentation" onClick={() => settype('propose')}>
                                    <a href="javascript:void(0)"
                                        className={`w-full nav-link block text-xs21 font-semibold text-[#808285] order-summary ${type === 'propose' ? 'active' : ''} relative`}
                                        id="pills-profile-tab" data-bs-toggle="pill"
                                        data-bs-target="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">
                                        Proposed Summary
                                    </a>
                                </li>
                            </>

                        </ul> :
                        <p className="sm:text-lg text-base font-semibold text-[#090406]">Order Summary</p>
                    }
                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane fade show  active px-1"
                            id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"></div>
                        {type === 'order' && <EubSummarySection
                            Calculation={Calculation.summary}
                            orderFlow={orderFlow}
                            GetCalculation={GetCalculation}
                            adorCashCheck={adorCashCheck}
                            setadorCashCheck={setadorCashCheck}
                            Privilages={Privilages}
                            cartCategory={cartCategory}
                        />}
                        {type !== 'order' && <EubSummarySection
                            type="order"
                            Calculation={Calculation.summary}
                            orderFlow={orderFlow}
                            GetCalculation={GetCalculation}
                            adorCashCheck={adorCashCheck}
                            setadorCashCheck={setadorCashCheck}
                            Privilages={Privilages}
                            cartCategory={cartCategory}
                        />}
                    </div>
                </div>
                <div className="mt-3">
                    <label className="text-m font-normal text-[#555259]">
                        End User Customer Name{orderFlow.order_type === 'Trade EUB Order' && <span className="text-[#FF3B30]">*</span>}
                    </label>
                    <input
                        type="text"
                        value={document.eu_name}
                        onChange={(e) => {
                            setEuNameError(false);
                            setdocument((prev) => ({ ...prev, eu_name: e.target.value }));
                        }}
                        style={{ border: `${euNameError ? '1px solid red' : '1px solid #707070'}` }}
                        className="mt-1 w-full rounded-lg text-sm font-normal text-[#000000] py-2 outline-0 px-3 placeholder:text-sm placeholder:text-[#808285] placeholder:font-normal"
                        placeholder="Enter End User Customer Name"
                        data-testid="eu-name-input"
                    />
                    {euNameError && (
                        <p className="text-xs3 font-normal text-[#ED1C24] mt-1">End User Customer Name is mandatory</p>
                    )}
                </div>
                <div className='pt-2'>
                    <p className="font-normal text-xs3 text-[#FF3B30] mt-1.5">{orderFlow.order_type !== 'Trade EUB Order' && <span className="text-[#FF3B30]">*</span>}Taxes & Duties are subject to change as per Government guidelines and will be charged as applicable at the time of dispatch</p>
                </div>
                {((orderFlow?.order_type === 'Trade Order' && ((!adorCashCheck &&  Calculation?.summary?.restrict_order) || (adorCashCheck && Calculation?.summary?.restrict_ador_cash_order))) || (orderFlow.order_type ==='Trade EUB Order' && ((!adorCashCheck && Calculation?.summary?.restrict_trade_eub_order) || (adorCashCheck && Calculation?.summary?.restrict_ador_cash_trade_eub_order)))) &&
                    <div className='mt-2'>
                        <p className="font-normal text-[12px] text-[#555259]"><span className="text-[#555259]">*</span>{`Order Value exceeds the credit balance, place order within Credit Balance (${handleAmount(Calculation?.summary?.credit_balance)})`}</p>
                    </div>}
                <div className="mt-3.5">
                    <button type="button"
                        onClick={() => {
                            if (orderFlow.order_type === 'Trade EUB Order' && !document.eu_name.trim()) {
                                setEuNameError(true);
                                return;
                            }
                            setdocumentModal(true);
                        }}
                        className="w-full sm:py-4 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF]"
                        data-bs-toggle="modal" data-bs-target="#addDocumnetation">
                        {orderFlow.order_type === 'Trade EUB Order' ? 'Add Documentation' : 'Place Order'}
                    </button>
                </div>
            </div>
            <ReactModal isOpen={documentModal}>
                <DocumentModal
                    setdocumentModal={setdocumentModal}
                    documentModal={documentModal}
                    documentData={document}
                    setdocument={setdocument}
                    handleSubmit={handleSubmit}
                    setloader={setloader}
                    loader={loader}
                    orderFlow={orderFlow}
                    restrictOrder={restrictOrder}
                    restrictTradeEUBOrder={restrictTradeEUBOrder}
                    restrictTradeAdorCash={restrictTradeAdorCash}
                    restrictEubAdorCash={restrictEubAdorCash}
                    adorCashCheck={adorCashCheck}
                    Calculation={Calculation?.summary}
                    type={type}
                />
            </ReactModal>
        </motion.div >
    )
}
